import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const basePath = '/api/needs-attention/address-change'

export const search = createApiAction('needs-attention/address-change/search', client.search(basePath))
export const changeStatus = createApiAction(
  'needs-attention/address-change/status',
  client.create(`${basePath}/:id/:action`),
)
export const update = createApiAction('needs-attention/address-change/update', client.update(`${basePath}/:id`))

const replaceItem = (state, action) => {
  state.list = state.list?.map(item => (String(item.id) === String(action.payload.id) ? action.payload : item))
}

const slice = createSlice({
  name: 'needs-attention/address-change',
  initialState: { list: null, error: null },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.error = null
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(search.rejected, (state, action) => {
        state.list = []
        state.error = action.error?.data?.error || action.error?.message || 'error'
      })
      .addCase(changeStatus.fulfilled, replaceItem)
      .addCase(update.fulfilled, replaceItem)
  },
})

export default slice.reducer
